import React, {Fragment} from "react";
import {ApplicationState, ConnectedReduxProps} from "@reducers/index";
import {Purchase} from "@models/purchase";
import PurchaseForm from "@components/purchases/Form";
import {injectIntl} from "react-intl";
import purchaseApi from "@api/purchase";


interface PropsFromState {
  loading: boolean;
  data: Purchase[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class PurchaseFormPage extends React.Component<AllProps> {
  state = {
    purchase: null,
    purchase_id: this.props.match.params.id,
    is_fetched: false
  };
  
  componentDidMount() {
    if (this.state.purchase_id) {
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    purchaseApi
      .getItem({
        params: {
          id: this.state.purchase_id,
        }
      })
      .then(({data}) => {
        this.setState({
          purchase: data
        });
      })
      .catch(error => {
      });
  };
  
  updateRequest = ({payload, params, onSuccessCallback, onErrorCallback, id}) => {
    purchaseApi.update({
        payload,
        params: {
          id: payload.purchase_id,
        },
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  createRequest = ({payload, onSuccessCallback, onErrorCallback}) => {
    purchaseApi.create({
        payload,
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  getContent = () => {
    if (this.state.purchase_id && !this.state.purchase) {
      return null;
    }
    
    return (
      <PurchaseForm
        purchase={this.state.purchase}
        intl={this.props.intl}
        id={this.state.purchase_id}
        listUrl={"/purchases"}
        history={this.props.history}
        updateRequest={this.updateRequest}
        createRequest={this.createRequest}
      />
    );
  };
  
  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}


export default injectIntl(PurchaseFormPage)




